import { createAuthClient } from 'better-auth/react';
import { organizationClient, adminClient } from 'better-auth/client/plugins';
import { ac, superadmin, user } from './permissions';

const API_URL = process.env.NEXT_PUBLIC_API_URL ?? process.env.API_URL;

if (!API_URL) {
  throw new Error('API_URL / NEXT_PUBLIC_API_URL is not defined');
}

export const AUTH_COOKIE_NAME = 'auth_token';
const TOKEN_MAX_AGE = 60 * 60 * 24 * 7; // 7 days — matches better-auth default session expiry

function readTokenFromCookie() {
  if (typeof document === 'undefined') return '';
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${AUTH_COOKIE_NAME}=([^;]*)`),
  );
  return match ? decodeURIComponent(match[1]) : '';
}

function writeTokenToCookie(token: string) {
  if (typeof document === 'undefined') return;
  const secure =
    typeof window !== 'undefined' && window.location.protocol === 'https:'
      ? '; Secure'
      : '';
  document.cookie = `${AUTH_COOKIE_NAME}=${encodeURIComponent(token)}; Path=/; Max-Age=${TOKEN_MAX_AGE}; SameSite=Lax${secure}`;
}

export function clearAuthToken() {
  if (typeof document === 'undefined') return;
  document.cookie = `${AUTH_COOKIE_NAME}=; Path=/; Max-Age=0; SameSite=Lax`;
}

export const authClient = createAuthClient({
  baseURL: API_URL.replace(/\/$/, ''),
  plugins: [
    organizationClient(),
    adminClient({
      ac,
      roles: {
        superadmin,
        user,
      },
    }),
  ],
  fetchOptions: {
    auth: {
      type: 'Bearer',
      token: readTokenFromCookie,
    },
    onSuccess(ctx) {
      const token = ctx.response.headers.get('set-auth-token');
      if (token) writeTokenToCookie(token);
    },
  },
});

export async function signOut() {
  try {
    await authClient.signOut();
  } finally {
    clearAuthToken();
  }
}
